import React from 'react';
import { Redirect } from 'react-router-dom';
import { useQueryParam, StringParam } from 'use-query-params';

const VerifyRedirect = () => {
  const [error] = useQueryParam('oidc_error', StringParam);

  if (error) {
    return (
      <Redirect
        to={{
          pathname: '/identity-verification/intro',
          search: `oidc_error=${error}`,
        }}
      />
    );
  }

  return <Redirect to={'/identity-verification/success'} />;
};

export default VerifyRedirect;
